import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { ComboService } from '../Model/Combo/combo.service';
import { CommonService } from '../Model/Common/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmployeeRegistrationService } from '../Model/EmployeeRegistration/employee-registration.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { SupportTicketService } from '../Model/Support/support-ticket.service';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import { ConfirmationComponent } from '../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../Component/Alert/alert-warning/alert-warning.component';
import { SessionService } from '../Util/Session/session.service';

@Component({
  selector: 'app-client-ticket-form',
  standalone: true,
  imports: [CommonModule, LoaderComponent, NgSelectModule, FormsModule],
  templateUrl: './client-ticket-form.component.html',
  styleUrl: './client-ticket-form.component.scss'
})
export class ClientTicketFormComponent {

  isDisabled: boolean = false;
  @Input() InputData: any;
  @Input() Status: any;
  ComplaintTypes: any[] = [];
  ComplaintType = null;
  selectedFile: File | null = null;
  Remark = '';
  user: any;

  constructor(
    protected common: CommonService,
    private combo: ComboService,
    public activeModal: NgbActiveModal,
    private employeeRegistration: EmployeeRegistrationService,
    private toast: ToastService,
    private modalService: NgbModal,
    private support: SupportTicketService,
    private tooltip: TooltipService,
    private session: SessionService
  ) { 
    this.user = session.GetUserDetails();
  }

  async ngOnInit(){
    console.log(this.InputData);
    await this.ESS_AdditionalFillCombo();
    this.Attachment = this.InputData.Attachment
    this.ImageUrl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + 'ClientPortalHelpdesk' + '/' + this.Attachment
    this.ComplaintType = this.InputData.ESS_ClientPortalComplaintTypeId
  }

  Attachment = '';
  ImageUrl = '';

  Close(type: boolean) {
    this.activeModal.close(type);
  }

  async save() {
    if (this.ComplaintType === '' || this.ComplaintType === null) {
      this.toast.show({ message: 'Please select Complaint Type.', type: toastTypeEnum.warning });
      return
    }
    if (this.Remark.trim() == '') {
      this.toast.show({ message: 'Please Enter Remark.', type: toastTypeEnum.warning });
      return
    }
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you Sure want to save ?'
    modalRef.result.then((result: any) => {
      // if (this.common.PageRight.IsAdd || this.common.PageRight.IsEdit) {
      if (result) {
        this.SaveUpdate();
      }
      // } else {
      //   this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      // }
    }).catch(() => {

    });
  }

  SaveUpdate() {
    const Detail = {
      SelectType: 'U',
      ESS_ClientPortalHelpDeskRequestId: this.InputData.ESS_ClientPortalHelpDeskRequestID,
      ESS_ClientPortalComplaintTypeId: this.InputData.ESS_ClientPortalComplaintTypeId,
      AdditionalDetails: this.InputData.AdditionalDetails,
      Tr_LoginMasterId: this.InputData.Tr_LoginMasterId,
      SiteId: this.InputData.SiteMasterId,
      ContactNo: this.InputData.ContactNo,
      Description: this.InputData.Description,
      Status: this.Status,
      Remarks: this.Remark,
      Email: this.InputData.Email,
      Attachment: this.InputData.Attachment,
      AssignedTo: this.user.UserId,
    }
    this.isDisabled = true;
    this.support.ClientPortal_HelpDeskRequestUpdate(Detail).subscribe({
      next: (data) => {
        if (data.ErrorCode == '453') {
          this.isDisabled = false
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.ErrorMessage;
          modalRef.result.then((result: any) => {
            if (result) {
              this.Close(true)
            }
          });
        }
        else {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.ErrorMessage;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
    });
  }

  removeFile() {
    this.selectedFile = null;
    this.Attachment = '';
    const fileInput = document.getElementById('formFileSm') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }
  viewFile() {
    window.open(this.ImageUrl, '_blank');
  }

  ESS_AdditionalFillCombo() {
    this.isDisabled = true;
    return new Promise((resolve, reject) => {
      this.employeeRegistration.ESS_AdditionalFillCombo({
      'SelectType': 'ClientPortalComplaintType',
    }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.ComplaintTypes = response.Table
          resolve(true);
        }
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
        reject(error);
      },
    });
    })
  }

}
